import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d25cd4bc")

_pushScopeId("data-v-d25cd4bc")
const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-montserrat font-semibold" }, " Pilih Transfer Bank ", -1)
const _hoisted_2 = { class: "mt-16" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "mt-8 text-12px xxl:text-14px font-normal" }, "Nomor Rekening", -1)
const _hoisted_4 = { class: "flex flex-row justify-between" }
const _hoisted_5 = { class: "text-20px font-semibold" }
const _hoisted_6 = { class: "text-16px font-semibold" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-16px font-montserrat font-semibold mt-5" }, " Cara Top Up ", -1)
const _hoisted_8 = { class: "mt-5 ml-6 text-12px xxl:text-14px" }
const _hoisted_9 = { class: "topup-manual-shadow absolute w-full -ml-8 bg-gray-lp-700 flex flex-row justify-between bottom-0 px-8 py-6" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "text-red-lp-100 underline text-13px font-medium" }, " Lihat Riwayat Transaksi ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BannerCashback = _resolveComponent("BannerCashback")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", {
    class: `tab-height px-8 py-4 overflow-auto ${_ctx.isAnyCashbackConfigActive ? 'pb-68' : 'pb-32'} text-black-lp-300`
  }, [
    _createVNode(_component_BannerCashback),
    _hoisted_1,
    _createVNode(_component_CustomDropdown, {
      class: "w-1/2 mt-2",
      options: _ctx.banks,
      onSelect: _ctx.onSelectMethodBank,
      selectedItem: _ctx.selectedBankManual,
      customChevronStyle: `w-6`,
      isCustomWidth: ""
    }, null, 8, ["options", "onSelect", "selectedItem"]),
    (_ctx.detailSelectedBankManual)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_2, [
            _createVNode("img", {
              src: _ctx.detailSelectedBankManual.internalBankAccountLogo,
              width: "110.6",
              alt: "bank_logo"
            }, null, 8, ["src"]),
            _hoisted_3,
            _createVNode("div", _hoisted_4, [
              _createVNode("p", _hoisted_5, _toDisplayString(_ctx.detailSelectedBankManual.internalBankAccountAccountNumber), 1),
              _createVNode("p", {
                class: "text-12px xxl:text-14px text-red-lp-500 font-medium cursor-pointer hover:underline",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (
              _ctx.copyManual(
                _ctx.detailSelectedBankManual.internalBankAccountAccountNumber
              )
            ))
              }, " Salin ")
            ]),
            _createVNode("p", _hoisted_6, " a/n " + _toDisplayString(_ctx.detailSelectedBankManual.internalBankAccountAccountName), 1)
          ]),
          _hoisted_7,
          _createVNode("div", _hoisted_8, [
            _withDirectives(_createVNode("div", null, null, 512), [
              [_directive_sanitize_html, 
            _ctx.detailSelectedBankManual.internalBankAccountIntruction
          ]
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_9, [
      _withDirectives(_createVNode("div", {
        class: "flex gap-x-2 items-center cursor-pointer",
        onClick: _cache[2] || (_cache[2] = () => _ctx.showTransactionHistory())
      }, [
        _hoisted_10,
        _createVNode("img", {
          src: require('@/app/ui/assets/svg/chevron-next.svg'),
          class: "w-6 max-w-none",
          alt: "next"
        }, null, 8, ["src"])
      ], 512), [
        [_vShow, _ctx.isViewTransactionHistory]
      ]),
      _createVNode(_component_lp_button, {
        textColor: "white",
        title: "Upload Bukti Transfer",
        class: "cursor-pointer",
        onClick: _cache[3] || (_cache[3] = () => _ctx.onUpload())
      })
    ])
  ], 2))
})